import React, { useState } from 'react';
import axios from 'axios';

const PostYoutubeLink = () => {
  const [youtubeLinkText, setYoutubeLinkText] = useState('');
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState(''); // For success or error messages
  const [messageType, setMessageType] = useState(''); // 'success' or 'error'

  const handleSubmit = async () => {
    setLoading(true);
    setMessage(''); // Clear previous messages
    setMessageType('');

    try {
      // Send a POST request to your server with the YouTube link text
      const response = await axios.post('https://api.indivtechnosoft.com/api/youtubelinks', {
        text: youtubeLinkText
      }, {
        headers: {
          'Content-Type': 'application/json'
        }
      });

      // Check if the request was successful
      if (response.status === 200) { // axios uses response.status for HTTP status
        setMessage('YouTube link submitted successfully!');
        setMessageType('success');
        setYoutubeLinkText(''); // Clear the input field on success
      } else {
        // If the request failed, log the error message
        setMessage(`Failed to submit YouTube link: ${response.data?.error || 'Unknown error'}`);
        setMessageType('error');
      }
    } catch (error) {
      console.error('Error:', error.message); // Log any unexpected errors
      setMessage(`Failed to submit YouTube link: ${error.response?.data?.error || error.message}`);
      setMessageType('error');
    } finally {
      setLoading(false);
    }
  };

  return (
    <section className="py-16 px-4 bg-gradient-to-br from-purple-50 to-indigo-50 min-h-screen flex items-center justify-center font-sans">
      <div className="w-full max-w-xl mx-auto bg-white rounded-2xl overflow-hidden shadow-xl p-8 md:p-10 border border-gray-200">
        <div className="text-center mb-10">
          <h2 className="text-4xl font-extrabold text-gray-800 mb-4 relative inline-block">
            Post <span className="text-purple-700">YouTube Link</span>
            <span className="block w-24 h-1.5 bg-purple-600 rounded-full mx-auto mt-3 transform scale-x-0 group-hover:scale-x-100 transition-transform duration-300 ease-out"></span>
          </h2>
          <p className="text-lg text-gray-600">Insert a YouTube link to fetch and display video data on the website.</p>
        </div>

        {message && (
          <div className={`p-4 mb-6 rounded-lg text-center ${messageType === 'success' ? 'bg-green-100 text-green-800 border border-green-300' : 'bg-red-100 text-red-800 border border-red-300'}`}>
            {message}
          </div>
        )}

        <div className="space-y-6">
          <div>
            <label htmlFor="youtubeLink" className="block text-gray-700 text-sm font-semibold mb-2">YouTube Link:</label>
            <input
              type="text"
              id="youtubeLink"
              value={youtubeLinkText}
              onChange={(e) => setYoutubeLinkText(e.target.value)}
              placeholder="Enter YouTube link here (e.g., https://www.youtube.com/watch?v=dQw4w9WgXcQ)"
              required
              className="w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-purple-500 transition-all duration-200 text-gray-800 placeholder-gray-400"
            />
          </div>
          <button
            onClick={handleSubmit}
            className="w-full bg-purple-600 text-white py-3 px-6 rounded-lg font-bold text-lg
                       hover:bg-purple-700 transition-all duration-300 shadow-md
                       focus:outline-none focus:ring-2 focus:ring-purple-500 focus:ring-offset-2 focus:ring-offset-white
                       disabled:opacity-50 disabled:cursor-not-allowed"
            disabled={loading}
          >
            {loading ? 'Submitting...' : 'Submit Link'}
          </button>
        </div>
      </div>
    </section>
  );
};

export default PostYoutubeLink;
